import './App.css';
import Weather from './component/Weather/Weather';
function App() {
  return (
    <div className="App">
     <Weather/>
    </div>
  );
}

export default App;
